<footer class="row ba-form-button-row">
    @if (backButton) {
        <div class="col ba-action-secondary">
            <a
                    href="#"
                    (click)="back($event)"
                    class="ba-btn ba-btn-secondary"
                    id="link-back"
                    [attr.aria-label]="backButton.label"
                    [class.ba-btn-left]="backButton.showArrow"
                    [class.disabled]="backButton.disabled"
            >
                {{ backButton.label }}
            </a>
        </div>
    }

    @if (storeButton) {
        <div class="col ba-action-tertiary">
            <button (click)="store($event)"
                    class="ba-btn ba-btn-tertiary"
                    id="btn-store"
                    [attr.aria-label]="storeButton.label"
                    type="submit"
                    [disabled]="storeButton.disabled"
            >
                {{ storeButton.label }}
            </button>
        </div>
    }

    @if (forwardButton) {
        <div class="col ba-action-primary">
            <a href="#"
               (click)="forward($event)"
               class="ba-btn ba-btn-primary"
               id="link-forward"
               [attr.aria-label]="forwardButton.label"
               [class.ba-btn-right]="forwardButton.showArrow"
               [class.disabled]="forwardButton.disabled">
                {{ forwardButton.label }}
            </a>
        </div>
    }
</footer>